interface Props {
    value: string;
    onChange: (val: string) => void;
  }
  
  const RevenueToggle: React.FC<Props> = ({ value, onChange }) => {
    const options = ["DAY", "MTD", "YTD"];
  
    return (
      <div className="flex gap-3 mb-4">
        {options.map((opt) => (
          <button
            key={opt}
            onClick={() => onChange(opt)}
            className={`px-4 py-2 rounded-md text-sm font-semibold ${
              value === opt
                ? "bg-[#6C63FF] text-white"
                : "bg-gray-200 text-gray-600"
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    );
  };
  
  export default RevenueToggle;
